/**
 * 获取港口类型列表
 * @returns {Array} 港口类型列表
 */
export const getPortTypeList = () => {
	return [
		{
			value: 1,
			label: '海港',
			valueEn: 'Sea Port',
		},
		{
			value: 2,
			label: '河港',
			valueEn: 'River Port',
		},
		{
			value: 4,
			label: '内陆点',
			valueEn: 'Inland Point',
		},
	]
}


/**
 * 获取港口航线列表
 * @returns {Array} 港口航线列表
 */
export const getPortLineList = () => {
	return [
    {
      id: 18842,
      parent_id: 0,
      line_code_name: "美加线",
      line_code_en_name: "North American",
      line_code_level: 1
    },
    {
      id: 18871,
      parent_id: 18851,
      line_code_name: "东非",
      line_code_en_name: "East Africa",
      line_code_level: 2
    },
    {
      id: 18866,
      parent_id: 18849,
      line_code_name: "中国",
      line_code_en_name: "China",
      line_code_level: 2
    },
    {
      id: 18861,
      parent_id: 18845,
      line_code_name: "澳洲",
      line_code_en_name: "Australia",
      line_code_level: 2
    },
    {
      id: 18852,
      parent_id: 18842,
      line_code_name: "美东",
      line_code_en_name: "East America",
      line_code_level: 2
    },
    {
      id: 18858,
      parent_id: 18844,
      line_code_name: "南美东",
      line_code_en_name: "South America East",
      line_code_level: 2
    },
    {
      id: 18855,
      parent_id: 18843,
      line_code_name: "欧洲",
      line_code_en_name: "Europe",
      line_code_level: 2
    },
    {
      id: 18843,
      parent_id: 0,
      line_code_name: "欧地线",
      line_code_en_name: "European Ground Wire",
      line_code_level: 1
    },
    {
      id: 18872,
      parent_id: 18851,
      line_code_name: "南非",
      line_code_en_name: "South Africa",
      line_code_level: 2
    },
    {
      id: 18862,
      parent_id: 18845,
      line_code_name: "新西兰",
      line_code_en_name: "New Zealand",
      line_code_level: 2
    },
    {
      id: 18859,
      parent_id: 18844,
      line_code_name: "南美西",
      line_code_en_name: "South America West",
      line_code_level: 2
    },
    {
      id: 18856,
      parent_id: 18843,
      line_code_name: "地中海",
      line_code_en_name: "Mediterranean Sea",
      line_code_level: 2
    },
    {
      id: 18853,
      parent_id: 18842,
      line_code_name: "美西",
      line_code_en_name: "West America",
      line_code_level: 2
    },
    {
      id: 18850,
      parent_id: 18849,
      line_code_name: "东南亚",
      line_code_en_name: "Southeast Asia",
      line_code_level: 2
    },
    {
      id: 18857,
      parent_id: 18843,
      line_code_name: "黑海",
      line_code_en_name: "Caspian Sea",
      line_code_level: 2
    },
    {
      id: 18873,
      parent_id: 18851,
      line_code_name: "西非",
      line_code_en_name: "West Africa",
      line_code_level: 2
    },
    {
      id: 18860,
      parent_id: 18844,
      line_code_name: "中美洲",
      line_code_en_name: "Central America",
      line_code_level: 2
    },
    {
      id: 18844,
      parent_id: 0,
      line_code_name: "拉美线",
      line_code_en_name: "Latin America Line",
      line_code_level: 1
    },
    {
      id: 18863,
      parent_id: 18845,
      line_code_name: "南太平洋",
      line_code_en_name: "South Pacific",
      line_code_level: 2
    },
    {
      id: 18869,
      parent_id: 18849,
      line_code_name: "远东",
      line_code_en_name: "Eastern",
      line_code_level: 2
    },
    {
      id: 18854,
      parent_id: 18842,
      line_code_name: "加拿大",
      line_code_en_name: "Canada",
      line_code_level: 2
    },
    {
      id: 18874,
      parent_id: 18851,
      line_code_name: "北非",
      line_code_en_name: "North Africa",
      line_code_level: 2
    },
    {
      id: 18845,
      parent_id: 0,
      line_code_name: "澳新线",
      line_code_en_name: "ANZ Line",
      line_code_level: 1
    },
    {
      id: 18870,
      parent_id: 18849,
      line_code_name: "中亚",
      line_code_en_name: "Central Asia",
      line_code_level: 2
    },
    {
      id: 18875,
      parent_id: 18844,
      line_code_name: "巴拿马",
      line_code_en_name: "Panama",
      line_code_level: 2
    },
    {
      id: 18878,
      parent_id: 18842,
      line_code_name: "美国内陆点",
      line_code_en_name: "US Inland",
      line_code_level: 2
    },
    {
      id: 18867,
      parent_id: 18849,
      line_code_name: "日韩",
      line_code_en_name: "Japan Korea",
      line_code_level: 2
    },
    {
      id: 18876,
      parent_id: 18844,
      line_code_name: "加勒比海",
      line_code_en_name: "Caribbean Sea",
      line_code_level: 2
    },
    {
      id: 18877,
      parent_id: 18843,
      line_code_name: "亚得里亚海",
      line_code_en_name: "Adriatic Sea",
      line_code_level: 2
    },
    {
      id: 18879,
      parent_id: 18844,
      line_code_name: "墨西哥",
      line_code_en_name: "Mexico",
      line_code_level: 2
    },
    {
      id: 18868,
      parent_id: 18849,
      line_code_name: "港澳",
      line_code_en_name: "HK Macao",
      line_code_level: 2
    },
    {
      id: 18864,
      parent_id: 18849,
      line_code_name: "中东",
      line_code_en_name: "Middle East",
      line_code_level: 2
    },
    {
      id: 18849,
      parent_id: 0,
      line_code_name: "亚洲线",
      line_code_en_name: "Asia Line",
      line_code_level: 1
    },
    {
      id: 18865,
      parent_id: 18849,
      line_code_name: "印巴",
      line_code_en_name: "India Pakistan",
      line_code_level: 2
    },
    {
      id: 18851,
      parent_id: 0,
      line_code_name: "非洲线",
      line_code_en_name: "African Line",
      line_code_level: 1
    },
    {
      id: 18847,
      parent_id: 18849,
      line_code_name: "红海",
      line_code_en_name: "Red Ocean",
      line_code_level: 2
    },
    {
      id: 18880,
      parent_id: 18849,
      line_code_name: "台湾",
      line_code_en_name: "Taiwan",
      line_code_level: 2
    }
  ]
}

export const getPortLineTree = (parentId = 0) => {
  const portLineTree = []
  // 先获取parent_id=0的港口航线
  const parentList = getPortLineList().filter(item => item.parent_id === parentId)
  parentList.forEach(item => {
    const childList = getPortLineTree(item.id)
    if(childList?.length > 0) {
      portLineTree.push({
        value: item.id,
        label: item.line_code_name,
        valueEn: item.line_code_en_name,
        children: childList
      })
    } else {
      portLineTree.push({
        value: item.id,
        label: item.line_code_name,
        valueEn: item.line_code_en_name
      })
    }
  })
  
  return portLineTree
}
